import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axiosInstance from '../../utils/axios';
import './ConfirmEmailPage.css';

function ConfirmEmailPage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('loading'); // loading, success, error
    const [message, setMessage] = useState('');

    useEffect(() => {
        const token = searchParams.get('token');
        
        if (!token) {
            setStatus('error');
            setMessage('Kinnituse tunnus puudub.');
            return;
        }

        // Call the confirmation endpoint
        axiosInstance.get(`/api/public/confirm-email?token=${token}`)
            .then(() => {
                setStatus('success');
                setMessage('Sinu meiliaadress on kinnitatud. Nüüd saad sisse logida.');
                // Redirect to login after 3 seconds
                setTimeout(() => {
                    navigate('/login');
                }, 3000);
            })
            .catch((error) => {
                setStatus('error');
                const errorMsg = error.response?.data?.message || 
                               error.response?.data || 
                               'Meiliaadressi kinnitamine ebaõnnestus. Link võib olla vigane või aegunud.';
                setMessage(errorMsg);
            });
    }, [searchParams, navigate]);

    return (
        <div className="confirm-email-container">
            <div className="confirm-email-box">
                {status === 'loading' && (
                    <>
                        <div className="spinner"></div>
                        <h2>Meiliaadressi kinnitamine...</h2>
                        <p>Palun oota, kuni meiliaadressi kontrollitakse.</p>
                    </>
                )}
                {status === 'success' && (
                    <>
                        <div className="success-icon">✓</div>
                        <h2>Meiliaadress kinnitatud!</h2>
                        <p>{message}</p>
                        <p style={{ fontSize: '14px', color: '#334155', marginTop: '10px' }}>
                            Suunamine sisselogimise lehele...
                        </p>
                        <button 
                            onClick={() => navigate('/login')} 
                            className="login-button"
                            style={{ marginTop: '20px' }}
                        >
                            Logi sisse
                        </button>
                    </>
                )}
                {status === 'error' && (
                    <>
                        <div className="error-icon">✗</div>
                        <h2>Kinnitamine ebaõnnestus</h2>
                        <p>{message}</p>
                        <div style={{ marginTop: '20px' }}>
                            <button 
                                onClick={() => navigate('/register')} 
                                className="register-button"
                                style={{ marginRight: '10px' }}
                            >
                                Registreeru uuesti
                            </button>
                            <button 
                                onClick={() => navigate('/login')} 
                                className="login-button"
                            >
                                Logi sisse
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default ConfirmEmailPage;

